import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MaxSizeValidator } from "@angular-material-components/file-input";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { fuseAnimations } from "@fuse/animations";
import { CustomValidationService } from "app/main/apps/shared/services/util/customvalidation.service";
import { OrdenesCompraService } from "app/main/apps/shared/services/rest/orden-compra.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-dialog-asociar-rocges",
    templateUrl: "./dialog-asociar-rocges.component.html",
    styleUrls: ["./dialog-asociar-rocges.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DialogAsociarRocgesComponent implements OnInit {
    formulario: FormGroup;
    maxSize = 2;
    file: File;
    blob:Blob=null;
    tieneAdjunto:boolean=false;
    esSupervisor:boolean=false;
    constructor(
        public dialogRef: MatDialogRef<DialogAsociarRocgesComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private _ordenesCompraSrvc: OrdenesCompraService,
        public menuUsuarioSrvc: MenuUsuarioService
    ) {}

    async ngOnInit(): Promise<void> {
        
        this.esSupervisor=this.menuUsuarioSrvc.esSupervisor();
        if (this.data.tieneImagen){
            this.tieneAdjunto=true;
            await this.getFileFromBack(this.data.idOOCC);
        }
        this.initFormFactura();
    }

    async getFileFromBack(id:number){
        this._ordenesCompraSrvc.fetchDocumento(this.data.idOOCC).subscribe(blob=>{
            this.blob=blob;
        });
    }

    bajarInforme(){
        const a = document.createElement('a');
        let url = window.URL.createObjectURL(this.blob);
        a.setAttribute('download', 'InformeOOCC');
        a.href = url;
        a.click();
    }

   async initFormFactura() {
        this.formulario = this.fb.group({
            numero: [
                this.data.numeroGes,
                { validators: [Validators.required, Validators.maxLength(20)] },
            ],
            informe: [
                this.file,
                [, MaxSizeValidator(this.maxSize * 1024 * 1024)],
            ],
            //informe:[this.file, [, MaxSizeValidator((this.maxSize * 1024)*1024)]]
        });
    }

    get numero() {
        return this.formulario.get("numero");
    }

    get informe() {
        return this.formulario.get("informe");
    }

    getFile(event) {
        this.file = event && event.item(0);
        this.tieneAdjunto=true;
    }

    cerrar() {
        const data = {
            form: this.formulario.value,
            informe: this.file instanceof File ? this.file : <File>this.blob,
        };

        this.dialogRef.close(data);
    }
}
